/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnderConstructionRouteImport } from './routes/under-construction'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardUnderConstructionRouteImport } from './routes/dashboard/under-construction'
import { Route as DashboardSquaresRouteRouteImport } from './routes/dashboard/squares/route'
import { Route as DashboardLobbyRouteRouteImport } from './routes/dashboard/lobby/route'
import { Route as DashboardDailyRevealRouteRouteImport } from './routes/dashboard/daily-reveal/route'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardTenantsIndexRouteImport } from './routes/dashboard/tenants/index'
import { Route as DashboardSquaresIndexRouteImport } from './routes/dashboard/squares/index'
import { Route as DashboardSimulationIndexRouteImport } from './routes/dashboard/simulation/index'
import { Route as DashboardQuestionsIndexRouteImport } from './routes/dashboard/questions/index'
import { Route as DashboardPrizePayoutsIndexRouteImport } from './routes/dashboard/prize-payouts/index'
import { Route as DashboardPickemsIndexRouteImport } from './routes/dashboard/pickems/index'
import { Route as DashboardLiveScoringIndexRouteImport } from './routes/dashboard/live-scoring/index'
import { Route as DashboardDevToolsIndexRouteImport } from './routes/dashboard/dev-tools/index'
import { Route as DashboardDailyRevealIndexRouteImport } from './routes/dashboard/daily-reveal/index'
import { Route as DashboardAuditLogIndexRouteImport } from './routes/dashboard/audit-log/index'
import { Route as DashboardAdminUsersIndexRouteImport } from './routes/dashboard/admin-users/index'
import { Route as DashboardUsersIdRouteImport } from './routes/dashboard/users/$id'
import { Route as DashboardTenantsIdRouteImport } from './routes/dashboard/tenants/$id'
import { Route as DashboardSquaresSettingsRouteImport } from './routes/dashboard/squares/settings'
import { Route as DashboardSquaresIdRouteImport } from './routes/dashboard/squares/$id'
import { Route as DashboardQuestionsIdRouteImport } from './routes/dashboard/questions/$id'
import { Route as DashboardPickemsSettingsRouteImport } from './routes/dashboard/pickems/settings'
import { Route as DashboardPickemsIdRouteImport } from './routes/dashboard/pickems/$id'
import { Route as DashboardLiveScoringPickemIdRouteImport } from './routes/dashboard/live-scoring/$pickemId'
import { Route as DashboardDailyRevealSettingsRouteImport } from './routes/dashboard/daily-reveal/settings'
import { Route as DashboardDailyRevealIdRouteImport } from './routes/dashboard/daily-reveal/$id'
import { Route as DashboardTenantTenantCodeRouteRouteImport } from './routes/dashboard/tenant/$tenantCode/route'
import { Route as DashboardSportsIdIndexRouteImport } from './routes/dashboard/sports/$id/index'
import { Route as DashboardLobbyTenantCodeIndexRouteImport } from './routes/dashboard/lobby/$tenantCode/index'
import { Route as DashboardTenantTenantCodeSecurityRouteImport } from './routes/dashboard/tenant/$tenantCode/security'
import { Route as DashboardTenantTenantCodeMarketingConsentRouteImport } from './routes/dashboard/tenant/$tenantCode/marketing-consent'
import { Route as DashboardTenantTenantCodeIpWhitelistRouteImport } from './routes/dashboard/tenant/$tenantCode/ip-whitelist'
import { Route as DashboardTenantTenantCodeImageLibraryRouteImport } from './routes/dashboard/tenant/$tenantCode/image-library'
import { Route as DashboardTenantTenantCodeFeaturesRouteImport } from './routes/dashboard/tenant/$tenantCode/features'
import { Route as DashboardTenantTenantCodeComplianceRouteImport } from './routes/dashboard/tenant/$tenantCode/compliance'
import { Route as DashboardTenantTenantCodeBrandingRouteImport } from './routes/dashboard/tenant/$tenantCode/branding'
import { Route as DashboardLobbyTenantCodeSettingsRouteImport } from './routes/dashboard/lobby/$tenantCode/settings'
import { Route as DashboardLobbyTenantCodeLobbyIdRouteImport } from './routes/dashboard/lobby/$tenantCode/$lobbyId'
import { Route as DashboardTenantTenantCodeGoogleAdsRouteRouteImport } from './routes/dashboard/tenant/$tenantCode/google-ads/route'
import { Route as DashboardTenantTenantCodePayoutTemplatesIndexRouteImport } from './routes/dashboard/tenant/$tenantCode/payout-templates/index'
import { Route as DashboardSportsIdTeamsIndexRouteImport } from './routes/dashboard/sports/$id/teams/index'
import { Route as DashboardSportsIdPlayersIndexRouteImport } from './routes/dashboard/sports/$id/players/index'
import { Route as DashboardTenantTenantCodePayoutTemplatesNewRouteImport } from './routes/dashboard/tenant/$tenantCode/payout-templates/new'
import { Route as DashboardTenantTenantCodePayoutTemplatesTemplateIdRouteImport } from './routes/dashboard/tenant/$tenantCode/payout-templates/$templateId'
import { Route as DashboardTenantTenantCodeGoogleAdsPlacementsRouteImport } from './routes/dashboard/tenant/$tenantCode/google-ads/placements'
import { Route as DashboardTenantTenantCodeGoogleAdsGamConfigRouteImport } from './routes/dashboard/tenant/$tenantCode/google-ads/gam-config'
import { Route as DashboardSportsIdTeamsNewRouteImport } from './routes/dashboard/sports/$id/teams/new'
import { Route as DashboardSportsIdTeamsTeamIdRouteImport } from './routes/dashboard/sports/$id/teams/$teamId'
import { Route as DashboardSportsIdPlayersNewRouteImport } from './routes/dashboard/sports/$id/players/new'
import { Route as DashboardSportsIdPlayersPlayerIdRouteImport } from './routes/dashboard/sports/$id/players/$playerId'
import { Route as DashboardSportsIdMatchesMatchIdStatsRouteImport } from './routes/dashboard/sports/$id/matches/$matchId/stats'

const UnderConstructionRoute = UnderConstructionRouteImport.update({
  id: '/under-construction',
  path: '/under-construction',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardUnderConstructionRoute =
  DashboardUnderConstructionRouteImport.update({
    id: '/under-construction',
    path: '/under-construction',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSquaresRouteRoute = DashboardSquaresRouteRouteImport.update({
  id: '/squares',
  path: '/squares',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLobbyRouteRoute = DashboardLobbyRouteRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDailyRevealRouteRoute =
  DashboardDailyRevealRouteRouteImport.update({
    id: '/daily-reveal',
    path: '/daily-reveal',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTenantsIndexRoute = DashboardTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSquaresIndexRoute = DashboardSquaresIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSquaresRouteRoute,
} as any)
const DashboardSimulationIndexRoute =
  DashboardSimulationIndexRouteImport.update({
    id: '/simulation/',
    path: '/simulation/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardQuestionsIndexRoute = DashboardQuestionsIndexRouteImport.update({
  id: '/questions/',
  path: '/questions/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPrizePayoutsIndexRoute =
  DashboardPrizePayoutsIndexRouteImport.update({
    id: '/prize-payouts/',
    path: '/prize-payouts/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPickemsIndexRoute = DashboardPickemsIndexRouteImport.update({
  id: '/pickems/',
  path: '/pickems/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLiveScoringIndexRoute =
  DashboardLiveScoringIndexRouteImport.update({
    id: '/live-scoring/',
    path: '/live-scoring/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDevToolsIndexRoute = DashboardDevToolsIndexRouteImport.update({
  id: '/dev-tools/',
  path: '/dev-tools/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDailyRevealIndexRoute =
  DashboardDailyRevealIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDailyRevealRouteRoute,
  } as any)
const DashboardAuditLogIndexRoute = DashboardAuditLogIndexRouteImport.update({
  id: '/audit-log/',
  path: '/audit-log/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminUsersIndexRoute =
  DashboardAdminUsersIndexRouteImport.update({
    id: '/admin-users/',
    path: '/admin-users/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardUsersIdRoute = DashboardUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTenantsIdRoute = DashboardTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSquaresSettingsRoute =
  DashboardSquaresSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardSquaresRouteRoute,
  } as any)
const DashboardSquaresIdRoute = DashboardSquaresIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardSquaresRouteRoute,
} as any)
const DashboardQuestionsIdRoute = DashboardQuestionsIdRouteImport.update({
  id: '/questions/$id',
  path: '/questions/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPickemsSettingsRoute =
  DashboardPickemsSettingsRouteImport.update({
    id: '/pickems/settings',
    path: '/pickems/settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPickemsIdRoute = DashboardPickemsIdRouteImport.update({
  id: '/pickems/$id',
  path: '/pickems/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLiveScoringPickemIdRoute =
  DashboardLiveScoringPickemIdRouteImport.update({
    id: '/live-scoring/$pickemId',
    path: '/live-scoring/$pickemId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDailyRevealSettingsRoute =
  DashboardDailyRevealSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardDailyRevealRouteRoute,
  } as any)
const DashboardDailyRevealIdRoute = DashboardDailyRevealIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardDailyRevealRouteRoute,
} as any)
const DashboardTenantTenantCodeRouteRoute =
  DashboardTenantTenantCodeRouteRouteImport.update({
    id: '/tenant/$tenantCode',
    path: '/tenant/$tenantCode',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdIndexRoute = DashboardSportsIdIndexRouteImport.update({
  id: '/sports/$id/',
  path: '/sports/$id/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLobbyTenantCodeIndexRoute =
  DashboardLobbyTenantCodeIndexRouteImport.update({
    id: '/$tenantCode/',
    path: '/$tenantCode/',
    getParentRoute: () => DashboardLobbyRouteRoute,
  } as any)
const DashboardTenantTenantCodeSecurityRoute =
  DashboardTenantTenantCodeSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeMarketingConsentRoute =
  DashboardTenantTenantCodeMarketingConsentRouteImport.update({
    id: '/marketing-consent',
    path: '/marketing-consent',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeIpWhitelistRoute =
  DashboardTenantTenantCodeIpWhitelistRouteImport.update({
    id: '/ip-whitelist',
    path: '/ip-whitelist',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeImageLibraryRoute =
  DashboardTenantTenantCodeImageLibraryRouteImport.update({
    id: '/image-library',
    path: '/image-library',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeFeaturesRoute =
  DashboardTenantTenantCodeFeaturesRouteImport.update({
    id: '/features',
    path: '/features',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeComplianceRoute =
  DashboardTenantTenantCodeComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeBrandingRoute =
  DashboardTenantTenantCodeBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardLobbyTenantCodeSettingsRoute =
  DashboardLobbyTenantCodeSettingsRouteImport.update({
    id: '/$tenantCode/settings',
    path: '/$tenantCode/settings',
    getParentRoute: () => DashboardLobbyRouteRoute,
  } as any)
const DashboardLobbyTenantCodeLobbyIdRoute =
  DashboardLobbyTenantCodeLobbyIdRouteImport.update({
    id: '/$tenantCode/$lobbyId',
    path: '/$tenantCode/$lobbyId',
    getParentRoute: () => DashboardLobbyRouteRoute,
  } as any)
const DashboardTenantTenantCodeGoogleAdsRouteRoute =
  DashboardTenantTenantCodeGoogleAdsRouteRouteImport.update({
    id: '/google-ads',
    path: '/google-ads',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodePayoutTemplatesIndexRoute =
  DashboardTenantTenantCodePayoutTemplatesIndexRouteImport.update({
    id: '/payout-templates/',
    path: '/payout-templates/',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardSportsIdTeamsIndexRoute =
  DashboardSportsIdTeamsIndexRouteImport.update({
    id: '/sports/$id/teams/',
    path: '/sports/$id/teams/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdPlayersIndexRoute =
  DashboardSportsIdPlayersIndexRouteImport.update({
    id: '/sports/$id/players/',
    path: '/sports/$id/players/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantTenantCodePayoutTemplatesNewRoute =
  DashboardTenantTenantCodePayoutTemplatesNewRouteImport.update({
    id: '/payout-templates/new',
    path: '/payout-templates/new',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute =
  DashboardTenantTenantCodePayoutTemplatesTemplateIdRouteImport.update({
    id: '/payout-templates/$templateId',
    path: '/payout-templates/$templateId',
    getParentRoute: () => DashboardTenantTenantCodeRouteRoute,
  } as any)
const DashboardTenantTenantCodeGoogleAdsPlacementsRoute =
  DashboardTenantTenantCodeGoogleAdsPlacementsRouteImport.update({
    id: '/placements',
    path: '/placements',
    getParentRoute: () => DashboardTenantTenantCodeGoogleAdsRouteRoute,
  } as any)
const DashboardTenantTenantCodeGoogleAdsGamConfigRoute =
  DashboardTenantTenantCodeGoogleAdsGamConfigRouteImport.update({
    id: '/gam-config',
    path: '/gam-config',
    getParentRoute: () => DashboardTenantTenantCodeGoogleAdsRouteRoute,
  } as any)
const DashboardSportsIdTeamsNewRoute =
  DashboardSportsIdTeamsNewRouteImport.update({
    id: '/sports/$id/teams/new',
    path: '/sports/$id/teams/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdTeamsTeamIdRoute =
  DashboardSportsIdTeamsTeamIdRouteImport.update({
    id: '/sports/$id/teams/$teamId',
    path: '/sports/$id/teams/$teamId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdPlayersNewRoute =
  DashboardSportsIdPlayersNewRouteImport.update({
    id: '/sports/$id/players/new',
    path: '/sports/$id/players/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdPlayersPlayerIdRoute =
  DashboardSportsIdPlayersPlayerIdRouteImport.update({
    id: '/sports/$id/players/$playerId',
    path: '/sports/$id/players/$playerId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSportsIdMatchesMatchIdStatsRoute =
  DashboardSportsIdMatchesMatchIdStatsRouteImport.update({
    id: '/sports/$id/matches/$matchId/stats',
    path: '/sports/$id/matches/$matchId/stats',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/under-construction': typeof UnderConstructionRoute
  '/dashboard/daily-reveal': typeof DashboardDailyRevealRouteRouteWithChildren
  '/dashboard/lobby': typeof DashboardLobbyRouteRouteWithChildren
  '/dashboard/squares': typeof DashboardSquaresRouteRouteWithChildren
  '/dashboard/under-construction': typeof DashboardUnderConstructionRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/tenant/$tenantCode': typeof DashboardTenantTenantCodeRouteRouteWithChildren
  '/dashboard/daily-reveal/$id': typeof DashboardDailyRevealIdRoute
  '/dashboard/daily-reveal/settings': typeof DashboardDailyRevealSettingsRoute
  '/dashboard/live-scoring/$pickemId': typeof DashboardLiveScoringPickemIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/pickems/settings': typeof DashboardPickemsSettingsRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/squares/$id': typeof DashboardSquaresIdRoute
  '/dashboard/squares/settings': typeof DashboardSquaresSettingsRoute
  '/dashboard/tenants/$id': typeof DashboardTenantsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/admin-users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/audit-log': typeof DashboardAuditLogIndexRoute
  '/dashboard/daily-reveal/': typeof DashboardDailyRevealIndexRoute
  '/dashboard/dev-tools': typeof DashboardDevToolsIndexRoute
  '/dashboard/live-scoring': typeof DashboardLiveScoringIndexRoute
  '/dashboard/pickems': typeof DashboardPickemsIndexRoute
  '/dashboard/prize-payouts': typeof DashboardPrizePayoutsIndexRoute
  '/dashboard/questions': typeof DashboardQuestionsIndexRoute
  '/dashboard/simulation': typeof DashboardSimulationIndexRoute
  '/dashboard/squares/': typeof DashboardSquaresIndexRoute
  '/dashboard/tenants': typeof DashboardTenantsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/tenant/$tenantCode/google-ads': typeof DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren
  '/dashboard/lobby/$tenantCode/$lobbyId': typeof DashboardLobbyTenantCodeLobbyIdRoute
  '/dashboard/lobby/$tenantCode/settings': typeof DashboardLobbyTenantCodeSettingsRoute
  '/dashboard/tenant/$tenantCode/branding': typeof DashboardTenantTenantCodeBrandingRoute
  '/dashboard/tenant/$tenantCode/compliance': typeof DashboardTenantTenantCodeComplianceRoute
  '/dashboard/tenant/$tenantCode/features': typeof DashboardTenantTenantCodeFeaturesRoute
  '/dashboard/tenant/$tenantCode/image-library': typeof DashboardTenantTenantCodeImageLibraryRoute
  '/dashboard/tenant/$tenantCode/ip-whitelist': typeof DashboardTenantTenantCodeIpWhitelistRoute
  '/dashboard/tenant/$tenantCode/marketing-consent': typeof DashboardTenantTenantCodeMarketingConsentRoute
  '/dashboard/tenant/$tenantCode/security': typeof DashboardTenantTenantCodeSecurityRoute
  '/dashboard/lobby/$tenantCode': typeof DashboardLobbyTenantCodeIndexRoute
  '/dashboard/sports/$id': typeof DashboardSportsIdIndexRoute
  '/dashboard/sports/$id/players/$playerId': typeof DashboardSportsIdPlayersPlayerIdRoute
  '/dashboard/sports/$id/players/new': typeof DashboardSportsIdPlayersNewRoute
  '/dashboard/sports/$id/teams/$teamId': typeof DashboardSportsIdTeamsTeamIdRoute
  '/dashboard/sports/$id/teams/new': typeof DashboardSportsIdTeamsNewRoute
  '/dashboard/tenant/$tenantCode/google-ads/gam-config': typeof DashboardTenantTenantCodeGoogleAdsGamConfigRoute
  '/dashboard/tenant/$tenantCode/google-ads/placements': typeof DashboardTenantTenantCodeGoogleAdsPlacementsRoute
  '/dashboard/tenant/$tenantCode/payout-templates/$templateId': typeof DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute
  '/dashboard/tenant/$tenantCode/payout-templates/new': typeof DashboardTenantTenantCodePayoutTemplatesNewRoute
  '/dashboard/sports/$id/players': typeof DashboardSportsIdPlayersIndexRoute
  '/dashboard/sports/$id/teams': typeof DashboardSportsIdTeamsIndexRoute
  '/dashboard/tenant/$tenantCode/payout-templates': typeof DashboardTenantTenantCodePayoutTemplatesIndexRoute
  '/dashboard/sports/$id/matches/$matchId/stats': typeof DashboardSportsIdMatchesMatchIdStatsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/under-construction': typeof UnderConstructionRoute
  '/dashboard/lobby': typeof DashboardLobbyRouteRouteWithChildren
  '/dashboard/under-construction': typeof DashboardUnderConstructionRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/tenant/$tenantCode': typeof DashboardTenantTenantCodeRouteRouteWithChildren
  '/dashboard/daily-reveal/$id': typeof DashboardDailyRevealIdRoute
  '/dashboard/daily-reveal/settings': typeof DashboardDailyRevealSettingsRoute
  '/dashboard/live-scoring/$pickemId': typeof DashboardLiveScoringPickemIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/pickems/settings': typeof DashboardPickemsSettingsRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/squares/$id': typeof DashboardSquaresIdRoute
  '/dashboard/squares/settings': typeof DashboardSquaresSettingsRoute
  '/dashboard/tenants/$id': typeof DashboardTenantsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/admin-users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/audit-log': typeof DashboardAuditLogIndexRoute
  '/dashboard/daily-reveal': typeof DashboardDailyRevealIndexRoute
  '/dashboard/dev-tools': typeof DashboardDevToolsIndexRoute
  '/dashboard/live-scoring': typeof DashboardLiveScoringIndexRoute
  '/dashboard/pickems': typeof DashboardPickemsIndexRoute
  '/dashboard/prize-payouts': typeof DashboardPrizePayoutsIndexRoute
  '/dashboard/questions': typeof DashboardQuestionsIndexRoute
  '/dashboard/simulation': typeof DashboardSimulationIndexRoute
  '/dashboard/squares': typeof DashboardSquaresIndexRoute
  '/dashboard/tenants': typeof DashboardTenantsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/tenant/$tenantCode/google-ads': typeof DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren
  '/dashboard/lobby/$tenantCode/$lobbyId': typeof DashboardLobbyTenantCodeLobbyIdRoute
  '/dashboard/lobby/$tenantCode/settings': typeof DashboardLobbyTenantCodeSettingsRoute
  '/dashboard/tenant/$tenantCode/branding': typeof DashboardTenantTenantCodeBrandingRoute
  '/dashboard/tenant/$tenantCode/compliance': typeof DashboardTenantTenantCodeComplianceRoute
  '/dashboard/tenant/$tenantCode/features': typeof DashboardTenantTenantCodeFeaturesRoute
  '/dashboard/tenant/$tenantCode/image-library': typeof DashboardTenantTenantCodeImageLibraryRoute
  '/dashboard/tenant/$tenantCode/ip-whitelist': typeof DashboardTenantTenantCodeIpWhitelistRoute
  '/dashboard/tenant/$tenantCode/marketing-consent': typeof DashboardTenantTenantCodeMarketingConsentRoute
  '/dashboard/tenant/$tenantCode/security': typeof DashboardTenantTenantCodeSecurityRoute
  '/dashboard/lobby/$tenantCode': typeof DashboardLobbyTenantCodeIndexRoute
  '/dashboard/sports/$id': typeof DashboardSportsIdIndexRoute
  '/dashboard/sports/$id/players/$playerId': typeof DashboardSportsIdPlayersPlayerIdRoute
  '/dashboard/sports/$id/players/new': typeof DashboardSportsIdPlayersNewRoute
  '/dashboard/sports/$id/teams/$teamId': typeof DashboardSportsIdTeamsTeamIdRoute
  '/dashboard/sports/$id/teams/new': typeof DashboardSportsIdTeamsNewRoute
  '/dashboard/tenant/$tenantCode/google-ads/gam-config': typeof DashboardTenantTenantCodeGoogleAdsGamConfigRoute
  '/dashboard/tenant/$tenantCode/google-ads/placements': typeof DashboardTenantTenantCodeGoogleAdsPlacementsRoute
  '/dashboard/tenant/$tenantCode/payout-templates/$templateId': typeof DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute
  '/dashboard/tenant/$tenantCode/payout-templates/new': typeof DashboardTenantTenantCodePayoutTemplatesNewRoute
  '/dashboard/sports/$id/players': typeof DashboardSportsIdPlayersIndexRoute
  '/dashboard/sports/$id/teams': typeof DashboardSportsIdTeamsIndexRoute
  '/dashboard/tenant/$tenantCode/payout-templates': typeof DashboardTenantTenantCodePayoutTemplatesIndexRoute
  '/dashboard/sports/$id/matches/$matchId/stats': typeof DashboardSportsIdMatchesMatchIdStatsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/under-construction': typeof UnderConstructionRoute
  '/dashboard/daily-reveal': typeof DashboardDailyRevealRouteRouteWithChildren
  '/dashboard/lobby': typeof DashboardLobbyRouteRouteWithChildren
  '/dashboard/squares': typeof DashboardSquaresRouteRouteWithChildren
  '/dashboard/under-construction': typeof DashboardUnderConstructionRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/tenant/$tenantCode': typeof DashboardTenantTenantCodeRouteRouteWithChildren
  '/dashboard/daily-reveal/$id': typeof DashboardDailyRevealIdRoute
  '/dashboard/daily-reveal/settings': typeof DashboardDailyRevealSettingsRoute
  '/dashboard/live-scoring/$pickemId': typeof DashboardLiveScoringPickemIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/pickems/settings': typeof DashboardPickemsSettingsRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/squares/$id': typeof DashboardSquaresIdRoute
  '/dashboard/squares/settings': typeof DashboardSquaresSettingsRoute
  '/dashboard/tenants/$id': typeof DashboardTenantsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/admin-users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/audit-log/': typeof DashboardAuditLogIndexRoute
  '/dashboard/daily-reveal/': typeof DashboardDailyRevealIndexRoute
  '/dashboard/dev-tools/': typeof DashboardDevToolsIndexRoute
  '/dashboard/live-scoring/': typeof DashboardLiveScoringIndexRoute
  '/dashboard/pickems/': typeof DashboardPickemsIndexRoute
  '/dashboard/prize-payouts/': typeof DashboardPrizePayoutsIndexRoute
  '/dashboard/questions/': typeof DashboardQuestionsIndexRoute
  '/dashboard/simulation/': typeof DashboardSimulationIndexRoute
  '/dashboard/squares/': typeof DashboardSquaresIndexRoute
  '/dashboard/tenants/': typeof DashboardTenantsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/tenant/$tenantCode/google-ads': typeof DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren
  '/dashboard/lobby/$tenantCode/$lobbyId': typeof DashboardLobbyTenantCodeLobbyIdRoute
  '/dashboard/lobby/$tenantCode/settings': typeof DashboardLobbyTenantCodeSettingsRoute
  '/dashboard/tenant/$tenantCode/branding': typeof DashboardTenantTenantCodeBrandingRoute
  '/dashboard/tenant/$tenantCode/compliance': typeof DashboardTenantTenantCodeComplianceRoute
  '/dashboard/tenant/$tenantCode/features': typeof DashboardTenantTenantCodeFeaturesRoute
  '/dashboard/tenant/$tenantCode/image-library': typeof DashboardTenantTenantCodeImageLibraryRoute
  '/dashboard/tenant/$tenantCode/ip-whitelist': typeof DashboardTenantTenantCodeIpWhitelistRoute
  '/dashboard/tenant/$tenantCode/marketing-consent': typeof DashboardTenantTenantCodeMarketingConsentRoute
  '/dashboard/tenant/$tenantCode/security': typeof DashboardTenantTenantCodeSecurityRoute
  '/dashboard/lobby/$tenantCode/': typeof DashboardLobbyTenantCodeIndexRoute
  '/dashboard/sports/$id/': typeof DashboardSportsIdIndexRoute
  '/dashboard/sports/$id/players/$playerId': typeof DashboardSportsIdPlayersPlayerIdRoute
  '/dashboard/sports/$id/players/new': typeof DashboardSportsIdPlayersNewRoute
  '/dashboard/sports/$id/teams/$teamId': typeof DashboardSportsIdTeamsTeamIdRoute
  '/dashboard/sports/$id/teams/new': typeof DashboardSportsIdTeamsNewRoute
  '/dashboard/tenant/$tenantCode/google-ads/gam-config': typeof DashboardTenantTenantCodeGoogleAdsGamConfigRoute
  '/dashboard/tenant/$tenantCode/google-ads/placements': typeof DashboardTenantTenantCodeGoogleAdsPlacementsRoute
  '/dashboard/tenant/$tenantCode/payout-templates/$templateId': typeof DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute
  '/dashboard/tenant/$tenantCode/payout-templates/new': typeof DashboardTenantTenantCodePayoutTemplatesNewRoute
  '/dashboard/sports/$id/players/': typeof DashboardSportsIdPlayersIndexRoute
  '/dashboard/sports/$id/teams/': typeof DashboardSportsIdTeamsIndexRoute
  '/dashboard/tenant/$tenantCode/payout-templates/': typeof DashboardTenantTenantCodePayoutTemplatesIndexRoute
  '/dashboard/sports/$id/matches/$matchId/stats': typeof DashboardSportsIdMatchesMatchIdStatsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/under-construction'
    | '/dashboard/daily-reveal'
    | '/dashboard/lobby'
    | '/dashboard/squares'
    | '/dashboard/under-construction'
    | '/dashboard/'
    | '/dashboard/tenant/$tenantCode'
    | '/dashboard/daily-reveal/$id'
    | '/dashboard/daily-reveal/settings'
    | '/dashboard/live-scoring/$pickemId'
    | '/dashboard/pickems/$id'
    | '/dashboard/pickems/settings'
    | '/dashboard/questions/$id'
    | '/dashboard/squares/$id'
    | '/dashboard/squares/settings'
    | '/dashboard/tenants/$id'
    | '/dashboard/users/$id'
    | '/dashboard/admin-users'
    | '/dashboard/audit-log'
    | '/dashboard/daily-reveal/'
    | '/dashboard/dev-tools'
    | '/dashboard/live-scoring'
    | '/dashboard/pickems'
    | '/dashboard/prize-payouts'
    | '/dashboard/questions'
    | '/dashboard/simulation'
    | '/dashboard/squares/'
    | '/dashboard/tenants'
    | '/dashboard/users'
    | '/dashboard/tenant/$tenantCode/google-ads'
    | '/dashboard/lobby/$tenantCode/$lobbyId'
    | '/dashboard/lobby/$tenantCode/settings'
    | '/dashboard/tenant/$tenantCode/branding'
    | '/dashboard/tenant/$tenantCode/compliance'
    | '/dashboard/tenant/$tenantCode/features'
    | '/dashboard/tenant/$tenantCode/image-library'
    | '/dashboard/tenant/$tenantCode/ip-whitelist'
    | '/dashboard/tenant/$tenantCode/marketing-consent'
    | '/dashboard/tenant/$tenantCode/security'
    | '/dashboard/lobby/$tenantCode'
    | '/dashboard/sports/$id'
    | '/dashboard/sports/$id/players/$playerId'
    | '/dashboard/sports/$id/players/new'
    | '/dashboard/sports/$id/teams/$teamId'
    | '/dashboard/sports/$id/teams/new'
    | '/dashboard/tenant/$tenantCode/google-ads/gam-config'
    | '/dashboard/tenant/$tenantCode/google-ads/placements'
    | '/dashboard/tenant/$tenantCode/payout-templates/$templateId'
    | '/dashboard/tenant/$tenantCode/payout-templates/new'
    | '/dashboard/sports/$id/players'
    | '/dashboard/sports/$id/teams'
    | '/dashboard/tenant/$tenantCode/payout-templates'
    | '/dashboard/sports/$id/matches/$matchId/stats'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/under-construction'
    | '/dashboard/lobby'
    | '/dashboard/under-construction'
    | '/dashboard'
    | '/dashboard/tenant/$tenantCode'
    | '/dashboard/daily-reveal/$id'
    | '/dashboard/daily-reveal/settings'
    | '/dashboard/live-scoring/$pickemId'
    | '/dashboard/pickems/$id'
    | '/dashboard/pickems/settings'
    | '/dashboard/questions/$id'
    | '/dashboard/squares/$id'
    | '/dashboard/squares/settings'
    | '/dashboard/tenants/$id'
    | '/dashboard/users/$id'
    | '/dashboard/admin-users'
    | '/dashboard/audit-log'
    | '/dashboard/daily-reveal'
    | '/dashboard/dev-tools'
    | '/dashboard/live-scoring'
    | '/dashboard/pickems'
    | '/dashboard/prize-payouts'
    | '/dashboard/questions'
    | '/dashboard/simulation'
    | '/dashboard/squares'
    | '/dashboard/tenants'
    | '/dashboard/users'
    | '/dashboard/tenant/$tenantCode/google-ads'
    | '/dashboard/lobby/$tenantCode/$lobbyId'
    | '/dashboard/lobby/$tenantCode/settings'
    | '/dashboard/tenant/$tenantCode/branding'
    | '/dashboard/tenant/$tenantCode/compliance'
    | '/dashboard/tenant/$tenantCode/features'
    | '/dashboard/tenant/$tenantCode/image-library'
    | '/dashboard/tenant/$tenantCode/ip-whitelist'
    | '/dashboard/tenant/$tenantCode/marketing-consent'
    | '/dashboard/tenant/$tenantCode/security'
    | '/dashboard/lobby/$tenantCode'
    | '/dashboard/sports/$id'
    | '/dashboard/sports/$id/players/$playerId'
    | '/dashboard/sports/$id/players/new'
    | '/dashboard/sports/$id/teams/$teamId'
    | '/dashboard/sports/$id/teams/new'
    | '/dashboard/tenant/$tenantCode/google-ads/gam-config'
    | '/dashboard/tenant/$tenantCode/google-ads/placements'
    | '/dashboard/tenant/$tenantCode/payout-templates/$templateId'
    | '/dashboard/tenant/$tenantCode/payout-templates/new'
    | '/dashboard/sports/$id/players'
    | '/dashboard/sports/$id/teams'
    | '/dashboard/tenant/$tenantCode/payout-templates'
    | '/dashboard/sports/$id/matches/$matchId/stats'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/under-construction'
    | '/dashboard/daily-reveal'
    | '/dashboard/lobby'
    | '/dashboard/squares'
    | '/dashboard/under-construction'
    | '/dashboard/'
    | '/dashboard/tenant/$tenantCode'
    | '/dashboard/daily-reveal/$id'
    | '/dashboard/daily-reveal/settings'
    | '/dashboard/live-scoring/$pickemId'
    | '/dashboard/pickems/$id'
    | '/dashboard/pickems/settings'
    | '/dashboard/questions/$id'
    | '/dashboard/squares/$id'
    | '/dashboard/squares/settings'
    | '/dashboard/tenants/$id'
    | '/dashboard/users/$id'
    | '/dashboard/admin-users/'
    | '/dashboard/audit-log/'
    | '/dashboard/daily-reveal/'
    | '/dashboard/dev-tools/'
    | '/dashboard/live-scoring/'
    | '/dashboard/pickems/'
    | '/dashboard/prize-payouts/'
    | '/dashboard/questions/'
    | '/dashboard/simulation/'
    | '/dashboard/squares/'
    | '/dashboard/tenants/'
    | '/dashboard/users/'
    | '/dashboard/tenant/$tenantCode/google-ads'
    | '/dashboard/lobby/$tenantCode/$lobbyId'
    | '/dashboard/lobby/$tenantCode/settings'
    | '/dashboard/tenant/$tenantCode/branding'
    | '/dashboard/tenant/$tenantCode/compliance'
    | '/dashboard/tenant/$tenantCode/features'
    | '/dashboard/tenant/$tenantCode/image-library'
    | '/dashboard/tenant/$tenantCode/ip-whitelist'
    | '/dashboard/tenant/$tenantCode/marketing-consent'
    | '/dashboard/tenant/$tenantCode/security'
    | '/dashboard/lobby/$tenantCode/'
    | '/dashboard/sports/$id/'
    | '/dashboard/sports/$id/players/$playerId'
    | '/dashboard/sports/$id/players/new'
    | '/dashboard/sports/$id/teams/$teamId'
    | '/dashboard/sports/$id/teams/new'
    | '/dashboard/tenant/$tenantCode/google-ads/gam-config'
    | '/dashboard/tenant/$tenantCode/google-ads/placements'
    | '/dashboard/tenant/$tenantCode/payout-templates/$templateId'
    | '/dashboard/tenant/$tenantCode/payout-templates/new'
    | '/dashboard/sports/$id/players/'
    | '/dashboard/sports/$id/teams/'
    | '/dashboard/tenant/$tenantCode/payout-templates/'
    | '/dashboard/sports/$id/matches/$matchId/stats'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnderConstructionRoute: typeof UnderConstructionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/under-construction': {
      id: '/under-construction'
      path: '/under-construction'
      fullPath: '/under-construction'
      preLoaderRoute: typeof UnderConstructionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/under-construction': {
      id: '/dashboard/under-construction'
      path: '/under-construction'
      fullPath: '/dashboard/under-construction'
      preLoaderRoute: typeof DashboardUnderConstructionRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/squares': {
      id: '/dashboard/squares'
      path: '/squares'
      fullPath: '/dashboard/squares'
      preLoaderRoute: typeof DashboardSquaresRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/lobby': {
      id: '/dashboard/lobby'
      path: '/lobby'
      fullPath: '/dashboard/lobby'
      preLoaderRoute: typeof DashboardLobbyRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/daily-reveal': {
      id: '/dashboard/daily-reveal'
      path: '/daily-reveal'
      fullPath: '/dashboard/daily-reveal'
      preLoaderRoute: typeof DashboardDailyRevealRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/': {
      id: '/dashboard/tenants/'
      path: '/tenants'
      fullPath: '/dashboard/tenants'
      preLoaderRoute: typeof DashboardTenantsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/squares/': {
      id: '/dashboard/squares/'
      path: '/'
      fullPath: '/dashboard/squares/'
      preLoaderRoute: typeof DashboardSquaresIndexRouteImport
      parentRoute: typeof DashboardSquaresRouteRoute
    }
    '/dashboard/simulation/': {
      id: '/dashboard/simulation/'
      path: '/simulation'
      fullPath: '/dashboard/simulation'
      preLoaderRoute: typeof DashboardSimulationIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/questions/': {
      id: '/dashboard/questions/'
      path: '/questions'
      fullPath: '/dashboard/questions'
      preLoaderRoute: typeof DashboardQuestionsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/prize-payouts/': {
      id: '/dashboard/prize-payouts/'
      path: '/prize-payouts'
      fullPath: '/dashboard/prize-payouts'
      preLoaderRoute: typeof DashboardPrizePayoutsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickems/': {
      id: '/dashboard/pickems/'
      path: '/pickems'
      fullPath: '/dashboard/pickems'
      preLoaderRoute: typeof DashboardPickemsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/live-scoring/': {
      id: '/dashboard/live-scoring/'
      path: '/live-scoring'
      fullPath: '/dashboard/live-scoring'
      preLoaderRoute: typeof DashboardLiveScoringIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/dev-tools/': {
      id: '/dashboard/dev-tools/'
      path: '/dev-tools'
      fullPath: '/dashboard/dev-tools'
      preLoaderRoute: typeof DashboardDevToolsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/daily-reveal/': {
      id: '/dashboard/daily-reveal/'
      path: '/'
      fullPath: '/dashboard/daily-reveal/'
      preLoaderRoute: typeof DashboardDailyRevealIndexRouteImport
      parentRoute: typeof DashboardDailyRevealRouteRoute
    }
    '/dashboard/audit-log/': {
      id: '/dashboard/audit-log/'
      path: '/audit-log'
      fullPath: '/dashboard/audit-log'
      preLoaderRoute: typeof DashboardAuditLogIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin-users/': {
      id: '/dashboard/admin-users/'
      path: '/admin-users'
      fullPath: '/dashboard/admin-users'
      preLoaderRoute: typeof DashboardAdminUsersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/users/$id': {
      id: '/dashboard/users/$id'
      path: '/users/$id'
      fullPath: '/dashboard/users/$id'
      preLoaderRoute: typeof DashboardUsersIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$id': {
      id: '/dashboard/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/dashboard/tenants/$id'
      preLoaderRoute: typeof DashboardTenantsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/squares/settings': {
      id: '/dashboard/squares/settings'
      path: '/settings'
      fullPath: '/dashboard/squares/settings'
      preLoaderRoute: typeof DashboardSquaresSettingsRouteImport
      parentRoute: typeof DashboardSquaresRouteRoute
    }
    '/dashboard/squares/$id': {
      id: '/dashboard/squares/$id'
      path: '/$id'
      fullPath: '/dashboard/squares/$id'
      preLoaderRoute: typeof DashboardSquaresIdRouteImport
      parentRoute: typeof DashboardSquaresRouteRoute
    }
    '/dashboard/questions/$id': {
      id: '/dashboard/questions/$id'
      path: '/questions/$id'
      fullPath: '/dashboard/questions/$id'
      preLoaderRoute: typeof DashboardQuestionsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickems/settings': {
      id: '/dashboard/pickems/settings'
      path: '/pickems/settings'
      fullPath: '/dashboard/pickems/settings'
      preLoaderRoute: typeof DashboardPickemsSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickems/$id': {
      id: '/dashboard/pickems/$id'
      path: '/pickems/$id'
      fullPath: '/dashboard/pickems/$id'
      preLoaderRoute: typeof DashboardPickemsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/live-scoring/$pickemId': {
      id: '/dashboard/live-scoring/$pickemId'
      path: '/live-scoring/$pickemId'
      fullPath: '/dashboard/live-scoring/$pickemId'
      preLoaderRoute: typeof DashboardLiveScoringPickemIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/daily-reveal/settings': {
      id: '/dashboard/daily-reveal/settings'
      path: '/settings'
      fullPath: '/dashboard/daily-reveal/settings'
      preLoaderRoute: typeof DashboardDailyRevealSettingsRouteImport
      parentRoute: typeof DashboardDailyRevealRouteRoute
    }
    '/dashboard/daily-reveal/$id': {
      id: '/dashboard/daily-reveal/$id'
      path: '/$id'
      fullPath: '/dashboard/daily-reveal/$id'
      preLoaderRoute: typeof DashboardDailyRevealIdRouteImport
      parentRoute: typeof DashboardDailyRevealRouteRoute
    }
    '/dashboard/tenant/$tenantCode': {
      id: '/dashboard/tenant/$tenantCode'
      path: '/tenant/$tenantCode'
      fullPath: '/dashboard/tenant/$tenantCode'
      preLoaderRoute: typeof DashboardTenantTenantCodeRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/': {
      id: '/dashboard/sports/$id/'
      path: '/sports/$id'
      fullPath: '/dashboard/sports/$id'
      preLoaderRoute: typeof DashboardSportsIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/lobby/$tenantCode/': {
      id: '/dashboard/lobby/$tenantCode/'
      path: '/$tenantCode'
      fullPath: '/dashboard/lobby/$tenantCode'
      preLoaderRoute: typeof DashboardLobbyTenantCodeIndexRouteImport
      parentRoute: typeof DashboardLobbyRouteRoute
    }
    '/dashboard/tenant/$tenantCode/security': {
      id: '/dashboard/tenant/$tenantCode/security'
      path: '/security'
      fullPath: '/dashboard/tenant/$tenantCode/security'
      preLoaderRoute: typeof DashboardTenantTenantCodeSecurityRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/marketing-consent': {
      id: '/dashboard/tenant/$tenantCode/marketing-consent'
      path: '/marketing-consent'
      fullPath: '/dashboard/tenant/$tenantCode/marketing-consent'
      preLoaderRoute: typeof DashboardTenantTenantCodeMarketingConsentRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/ip-whitelist': {
      id: '/dashboard/tenant/$tenantCode/ip-whitelist'
      path: '/ip-whitelist'
      fullPath: '/dashboard/tenant/$tenantCode/ip-whitelist'
      preLoaderRoute: typeof DashboardTenantTenantCodeIpWhitelistRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/image-library': {
      id: '/dashboard/tenant/$tenantCode/image-library'
      path: '/image-library'
      fullPath: '/dashboard/tenant/$tenantCode/image-library'
      preLoaderRoute: typeof DashboardTenantTenantCodeImageLibraryRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/features': {
      id: '/dashboard/tenant/$tenantCode/features'
      path: '/features'
      fullPath: '/dashboard/tenant/$tenantCode/features'
      preLoaderRoute: typeof DashboardTenantTenantCodeFeaturesRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/compliance': {
      id: '/dashboard/tenant/$tenantCode/compliance'
      path: '/compliance'
      fullPath: '/dashboard/tenant/$tenantCode/compliance'
      preLoaderRoute: typeof DashboardTenantTenantCodeComplianceRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/branding': {
      id: '/dashboard/tenant/$tenantCode/branding'
      path: '/branding'
      fullPath: '/dashboard/tenant/$tenantCode/branding'
      preLoaderRoute: typeof DashboardTenantTenantCodeBrandingRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/lobby/$tenantCode/settings': {
      id: '/dashboard/lobby/$tenantCode/settings'
      path: '/$tenantCode/settings'
      fullPath: '/dashboard/lobby/$tenantCode/settings'
      preLoaderRoute: typeof DashboardLobbyTenantCodeSettingsRouteImport
      parentRoute: typeof DashboardLobbyRouteRoute
    }
    '/dashboard/lobby/$tenantCode/$lobbyId': {
      id: '/dashboard/lobby/$tenantCode/$lobbyId'
      path: '/$tenantCode/$lobbyId'
      fullPath: '/dashboard/lobby/$tenantCode/$lobbyId'
      preLoaderRoute: typeof DashboardLobbyTenantCodeLobbyIdRouteImport
      parentRoute: typeof DashboardLobbyRouteRoute
    }
    '/dashboard/tenant/$tenantCode/google-ads': {
      id: '/dashboard/tenant/$tenantCode/google-ads'
      path: '/google-ads'
      fullPath: '/dashboard/tenant/$tenantCode/google-ads'
      preLoaderRoute: typeof DashboardTenantTenantCodeGoogleAdsRouteRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/payout-templates/': {
      id: '/dashboard/tenant/$tenantCode/payout-templates/'
      path: '/payout-templates'
      fullPath: '/dashboard/tenant/$tenantCode/payout-templates'
      preLoaderRoute: typeof DashboardTenantTenantCodePayoutTemplatesIndexRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/sports/$id/teams/': {
      id: '/dashboard/sports/$id/teams/'
      path: '/sports/$id/teams'
      fullPath: '/dashboard/sports/$id/teams'
      preLoaderRoute: typeof DashboardSportsIdTeamsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/players/': {
      id: '/dashboard/sports/$id/players/'
      path: '/sports/$id/players'
      fullPath: '/dashboard/sports/$id/players'
      preLoaderRoute: typeof DashboardSportsIdPlayersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenant/$tenantCode/payout-templates/new': {
      id: '/dashboard/tenant/$tenantCode/payout-templates/new'
      path: '/payout-templates/new'
      fullPath: '/dashboard/tenant/$tenantCode/payout-templates/new'
      preLoaderRoute: typeof DashboardTenantTenantCodePayoutTemplatesNewRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/payout-templates/$templateId': {
      id: '/dashboard/tenant/$tenantCode/payout-templates/$templateId'
      path: '/payout-templates/$templateId'
      fullPath: '/dashboard/tenant/$tenantCode/payout-templates/$templateId'
      preLoaderRoute: typeof DashboardTenantTenantCodePayoutTemplatesTemplateIdRouteImport
      parentRoute: typeof DashboardTenantTenantCodeRouteRoute
    }
    '/dashboard/tenant/$tenantCode/google-ads/placements': {
      id: '/dashboard/tenant/$tenantCode/google-ads/placements'
      path: '/placements'
      fullPath: '/dashboard/tenant/$tenantCode/google-ads/placements'
      preLoaderRoute: typeof DashboardTenantTenantCodeGoogleAdsPlacementsRouteImport
      parentRoute: typeof DashboardTenantTenantCodeGoogleAdsRouteRoute
    }
    '/dashboard/tenant/$tenantCode/google-ads/gam-config': {
      id: '/dashboard/tenant/$tenantCode/google-ads/gam-config'
      path: '/gam-config'
      fullPath: '/dashboard/tenant/$tenantCode/google-ads/gam-config'
      preLoaderRoute: typeof DashboardTenantTenantCodeGoogleAdsGamConfigRouteImport
      parentRoute: typeof DashboardTenantTenantCodeGoogleAdsRouteRoute
    }
    '/dashboard/sports/$id/teams/new': {
      id: '/dashboard/sports/$id/teams/new'
      path: '/sports/$id/teams/new'
      fullPath: '/dashboard/sports/$id/teams/new'
      preLoaderRoute: typeof DashboardSportsIdTeamsNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/teams/$teamId': {
      id: '/dashboard/sports/$id/teams/$teamId'
      path: '/sports/$id/teams/$teamId'
      fullPath: '/dashboard/sports/$id/teams/$teamId'
      preLoaderRoute: typeof DashboardSportsIdTeamsTeamIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/players/new': {
      id: '/dashboard/sports/$id/players/new'
      path: '/sports/$id/players/new'
      fullPath: '/dashboard/sports/$id/players/new'
      preLoaderRoute: typeof DashboardSportsIdPlayersNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/players/$playerId': {
      id: '/dashboard/sports/$id/players/$playerId'
      path: '/sports/$id/players/$playerId'
      fullPath: '/dashboard/sports/$id/players/$playerId'
      preLoaderRoute: typeof DashboardSportsIdPlayersPlayerIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/sports/$id/matches/$matchId/stats': {
      id: '/dashboard/sports/$id/matches/$matchId/stats'
      path: '/sports/$id/matches/$matchId/stats'
      fullPath: '/dashboard/sports/$id/matches/$matchId/stats'
      preLoaderRoute: typeof DashboardSportsIdMatchesMatchIdStatsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardDailyRevealRouteRouteChildren {
  DashboardDailyRevealIdRoute: typeof DashboardDailyRevealIdRoute
  DashboardDailyRevealSettingsRoute: typeof DashboardDailyRevealSettingsRoute
  DashboardDailyRevealIndexRoute: typeof DashboardDailyRevealIndexRoute
}

const DashboardDailyRevealRouteRouteChildren: DashboardDailyRevealRouteRouteChildren =
  {
    DashboardDailyRevealIdRoute: DashboardDailyRevealIdRoute,
    DashboardDailyRevealSettingsRoute: DashboardDailyRevealSettingsRoute,
    DashboardDailyRevealIndexRoute: DashboardDailyRevealIndexRoute,
  }

const DashboardDailyRevealRouteRouteWithChildren =
  DashboardDailyRevealRouteRoute._addFileChildren(
    DashboardDailyRevealRouteRouteChildren,
  )

interface DashboardLobbyRouteRouteChildren {
  DashboardLobbyTenantCodeLobbyIdRoute: typeof DashboardLobbyTenantCodeLobbyIdRoute
  DashboardLobbyTenantCodeSettingsRoute: typeof DashboardLobbyTenantCodeSettingsRoute
  DashboardLobbyTenantCodeIndexRoute: typeof DashboardLobbyTenantCodeIndexRoute
}

const DashboardLobbyRouteRouteChildren: DashboardLobbyRouteRouteChildren = {
  DashboardLobbyTenantCodeLobbyIdRoute: DashboardLobbyTenantCodeLobbyIdRoute,
  DashboardLobbyTenantCodeSettingsRoute: DashboardLobbyTenantCodeSettingsRoute,
  DashboardLobbyTenantCodeIndexRoute: DashboardLobbyTenantCodeIndexRoute,
}

const DashboardLobbyRouteRouteWithChildren =
  DashboardLobbyRouteRoute._addFileChildren(DashboardLobbyRouteRouteChildren)

interface DashboardSquaresRouteRouteChildren {
  DashboardSquaresIdRoute: typeof DashboardSquaresIdRoute
  DashboardSquaresSettingsRoute: typeof DashboardSquaresSettingsRoute
  DashboardSquaresIndexRoute: typeof DashboardSquaresIndexRoute
}

const DashboardSquaresRouteRouteChildren: DashboardSquaresRouteRouteChildren = {
  DashboardSquaresIdRoute: DashboardSquaresIdRoute,
  DashboardSquaresSettingsRoute: DashboardSquaresSettingsRoute,
  DashboardSquaresIndexRoute: DashboardSquaresIndexRoute,
}

const DashboardSquaresRouteRouteWithChildren =
  DashboardSquaresRouteRoute._addFileChildren(
    DashboardSquaresRouteRouteChildren,
  )

interface DashboardTenantTenantCodeGoogleAdsRouteRouteChildren {
  DashboardTenantTenantCodeGoogleAdsGamConfigRoute: typeof DashboardTenantTenantCodeGoogleAdsGamConfigRoute
  DashboardTenantTenantCodeGoogleAdsPlacementsRoute: typeof DashboardTenantTenantCodeGoogleAdsPlacementsRoute
}

const DashboardTenantTenantCodeGoogleAdsRouteRouteChildren: DashboardTenantTenantCodeGoogleAdsRouteRouteChildren =
  {
    DashboardTenantTenantCodeGoogleAdsGamConfigRoute:
      DashboardTenantTenantCodeGoogleAdsGamConfigRoute,
    DashboardTenantTenantCodeGoogleAdsPlacementsRoute:
      DashboardTenantTenantCodeGoogleAdsPlacementsRoute,
  }

const DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren =
  DashboardTenantTenantCodeGoogleAdsRouteRoute._addFileChildren(
    DashboardTenantTenantCodeGoogleAdsRouteRouteChildren,
  )

interface DashboardTenantTenantCodeRouteRouteChildren {
  DashboardTenantTenantCodeGoogleAdsRouteRoute: typeof DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren
  DashboardTenantTenantCodeBrandingRoute: typeof DashboardTenantTenantCodeBrandingRoute
  DashboardTenantTenantCodeComplianceRoute: typeof DashboardTenantTenantCodeComplianceRoute
  DashboardTenantTenantCodeFeaturesRoute: typeof DashboardTenantTenantCodeFeaturesRoute
  DashboardTenantTenantCodeImageLibraryRoute: typeof DashboardTenantTenantCodeImageLibraryRoute
  DashboardTenantTenantCodeIpWhitelistRoute: typeof DashboardTenantTenantCodeIpWhitelistRoute
  DashboardTenantTenantCodeMarketingConsentRoute: typeof DashboardTenantTenantCodeMarketingConsentRoute
  DashboardTenantTenantCodeSecurityRoute: typeof DashboardTenantTenantCodeSecurityRoute
  DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute: typeof DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute
  DashboardTenantTenantCodePayoutTemplatesNewRoute: typeof DashboardTenantTenantCodePayoutTemplatesNewRoute
  DashboardTenantTenantCodePayoutTemplatesIndexRoute: typeof DashboardTenantTenantCodePayoutTemplatesIndexRoute
}

const DashboardTenantTenantCodeRouteRouteChildren: DashboardTenantTenantCodeRouteRouteChildren =
  {
    DashboardTenantTenantCodeGoogleAdsRouteRoute:
      DashboardTenantTenantCodeGoogleAdsRouteRouteWithChildren,
    DashboardTenantTenantCodeBrandingRoute:
      DashboardTenantTenantCodeBrandingRoute,
    DashboardTenantTenantCodeComplianceRoute:
      DashboardTenantTenantCodeComplianceRoute,
    DashboardTenantTenantCodeFeaturesRoute:
      DashboardTenantTenantCodeFeaturesRoute,
    DashboardTenantTenantCodeImageLibraryRoute:
      DashboardTenantTenantCodeImageLibraryRoute,
    DashboardTenantTenantCodeIpWhitelistRoute:
      DashboardTenantTenantCodeIpWhitelistRoute,
    DashboardTenantTenantCodeMarketingConsentRoute:
      DashboardTenantTenantCodeMarketingConsentRoute,
    DashboardTenantTenantCodeSecurityRoute:
      DashboardTenantTenantCodeSecurityRoute,
    DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute:
      DashboardTenantTenantCodePayoutTemplatesTemplateIdRoute,
    DashboardTenantTenantCodePayoutTemplatesNewRoute:
      DashboardTenantTenantCodePayoutTemplatesNewRoute,
    DashboardTenantTenantCodePayoutTemplatesIndexRoute:
      DashboardTenantTenantCodePayoutTemplatesIndexRoute,
  }

const DashboardTenantTenantCodeRouteRouteWithChildren =
  DashboardTenantTenantCodeRouteRoute._addFileChildren(
    DashboardTenantTenantCodeRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardDailyRevealRouteRoute: typeof DashboardDailyRevealRouteRouteWithChildren
  DashboardLobbyRouteRoute: typeof DashboardLobbyRouteRouteWithChildren
  DashboardSquaresRouteRoute: typeof DashboardSquaresRouteRouteWithChildren
  DashboardUnderConstructionRoute: typeof DashboardUnderConstructionRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardTenantTenantCodeRouteRoute: typeof DashboardTenantTenantCodeRouteRouteWithChildren
  DashboardLiveScoringPickemIdRoute: typeof DashboardLiveScoringPickemIdRoute
  DashboardPickemsIdRoute: typeof DashboardPickemsIdRoute
  DashboardPickemsSettingsRoute: typeof DashboardPickemsSettingsRoute
  DashboardQuestionsIdRoute: typeof DashboardQuestionsIdRoute
  DashboardTenantsIdRoute: typeof DashboardTenantsIdRoute
  DashboardUsersIdRoute: typeof DashboardUsersIdRoute
  DashboardAdminUsersIndexRoute: typeof DashboardAdminUsersIndexRoute
  DashboardAuditLogIndexRoute: typeof DashboardAuditLogIndexRoute
  DashboardDevToolsIndexRoute: typeof DashboardDevToolsIndexRoute
  DashboardLiveScoringIndexRoute: typeof DashboardLiveScoringIndexRoute
  DashboardPickemsIndexRoute: typeof DashboardPickemsIndexRoute
  DashboardPrizePayoutsIndexRoute: typeof DashboardPrizePayoutsIndexRoute
  DashboardQuestionsIndexRoute: typeof DashboardQuestionsIndexRoute
  DashboardSimulationIndexRoute: typeof DashboardSimulationIndexRoute
  DashboardTenantsIndexRoute: typeof DashboardTenantsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardSportsIdIndexRoute: typeof DashboardSportsIdIndexRoute
  DashboardSportsIdPlayersPlayerIdRoute: typeof DashboardSportsIdPlayersPlayerIdRoute
  DashboardSportsIdPlayersNewRoute: typeof DashboardSportsIdPlayersNewRoute
  DashboardSportsIdTeamsTeamIdRoute: typeof DashboardSportsIdTeamsTeamIdRoute
  DashboardSportsIdTeamsNewRoute: typeof DashboardSportsIdTeamsNewRoute
  DashboardSportsIdPlayersIndexRoute: typeof DashboardSportsIdPlayersIndexRoute
  DashboardSportsIdTeamsIndexRoute: typeof DashboardSportsIdTeamsIndexRoute
  DashboardSportsIdMatchesMatchIdStatsRoute: typeof DashboardSportsIdMatchesMatchIdStatsRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardDailyRevealRouteRoute: DashboardDailyRevealRouteRouteWithChildren,
  DashboardLobbyRouteRoute: DashboardLobbyRouteRouteWithChildren,
  DashboardSquaresRouteRoute: DashboardSquaresRouteRouteWithChildren,
  DashboardUnderConstructionRoute: DashboardUnderConstructionRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardTenantTenantCodeRouteRoute:
    DashboardTenantTenantCodeRouteRouteWithChildren,
  DashboardLiveScoringPickemIdRoute: DashboardLiveScoringPickemIdRoute,
  DashboardPickemsIdRoute: DashboardPickemsIdRoute,
  DashboardPickemsSettingsRoute: DashboardPickemsSettingsRoute,
  DashboardQuestionsIdRoute: DashboardQuestionsIdRoute,
  DashboardTenantsIdRoute: DashboardTenantsIdRoute,
  DashboardUsersIdRoute: DashboardUsersIdRoute,
  DashboardAdminUsersIndexRoute: DashboardAdminUsersIndexRoute,
  DashboardAuditLogIndexRoute: DashboardAuditLogIndexRoute,
  DashboardDevToolsIndexRoute: DashboardDevToolsIndexRoute,
  DashboardLiveScoringIndexRoute: DashboardLiveScoringIndexRoute,
  DashboardPickemsIndexRoute: DashboardPickemsIndexRoute,
  DashboardPrizePayoutsIndexRoute: DashboardPrizePayoutsIndexRoute,
  DashboardQuestionsIndexRoute: DashboardQuestionsIndexRoute,
  DashboardSimulationIndexRoute: DashboardSimulationIndexRoute,
  DashboardTenantsIndexRoute: DashboardTenantsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardSportsIdIndexRoute: DashboardSportsIdIndexRoute,
  DashboardSportsIdPlayersPlayerIdRoute: DashboardSportsIdPlayersPlayerIdRoute,
  DashboardSportsIdPlayersNewRoute: DashboardSportsIdPlayersNewRoute,
  DashboardSportsIdTeamsTeamIdRoute: DashboardSportsIdTeamsTeamIdRoute,
  DashboardSportsIdTeamsNewRoute: DashboardSportsIdTeamsNewRoute,
  DashboardSportsIdPlayersIndexRoute: DashboardSportsIdPlayersIndexRoute,
  DashboardSportsIdTeamsIndexRoute: DashboardSportsIdTeamsIndexRoute,
  DashboardSportsIdMatchesMatchIdStatsRoute:
    DashboardSportsIdMatchesMatchIdStatsRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnderConstructionRoute: UnderConstructionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
